<template>
  <div>
    <p style="text-align: center; margin-top: 15px;">Are you sure you want terminate the Camunda Process Instance associated with this <strong>{{ data.name }}</strong> job?</p>
    <p style="text-align: center; margin-top: 15px;"><strong>NOTE</strong>: Any tasks below not deleted will be have their status set to Cancelled.</p>
    <hr />
    <h6>Select Task(s) to Delete</h6>
    <el-table class="table-striped wrap-whole-words"
              ref="taskSearchTable"
              :data="tasks"
              border
              @selection-change="handleSelectionChange"
              style="width: 100%">
      <el-table-column
        :selectable="selectableTask"
        type="selection"
        fixed="left"
        width="55">
      </el-table-column>
      <el-table-column
        :min-width="160"
        sortable
        :sort-method="(a, b) => callStringSort(a, b, 'name')"
        prop="name"
        label="Name">
        <template slot-scope="props">
          <span class="invisible">Task Id: {{ props.row.id }}</span>
          <a href="#" title="View/Edit Task" @click.prevent="handleEditTask(props.row.id)">{{ lodash.get(props.row, 'name') }}</a>
        </template>
      </el-table-column>
      <el-table-column
        label="Assignee"
        :min-width="140"
        prop="assignee"
        sortable
        :sort-method="(a, b) => callStringSort(a, b, 'assignee')"
        >
        <template slot-scope="props">
          {{ assigneeName(props.row.assigneeId) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Due Date"
        :min-width="150"
        sortable
        prop="dueDate">
        <template slot-scope="props">
          {{ props.row.dueDate | formatDate }}
        </template>
      </el-table-column>
      <el-table-column
        label="Status"
        :min-width="115"
        sortable
        :sort-method="(a, b) => callStringSort(a, b, 'status')"
        prop="status">
        <template v-slot="props">
          {{ props.row.status }}
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;" v-if="canTerminate">
      <button type="button" @click="confirmTerminate" class="btn btn-fill btn-info">
        Terminate Instance & Complete Job
      </button>
    </div>
  </div>
</template>

<script>
import {NO_CONTENT, OK} from 'http-status-codes'
import {mapGetters} from 'vuex'
import {getUserFullName, notifyError, notifySuccess, objectById, stringSort} from 'src/utilities/utils'
import {ptracDeleteEntity} from 'src/utilities/ptracApi'
import Constants from 'src/utilities/constants'
import lodash from 'lodash'
import Permissions from "@/utilities/permissions";

export default {
    props: ['data'],
    computed: {
      ...mapGetters({
        users: 'users/results'
      }),
      canTerminate() {
        return this.$can('edit', Permissions.JOB_TERMINATE_PROCESS_INSTANCE)
      }
    },
    data() {
      return {
        lodash,
        tasks: [],
        selectedTasks: []
      }
    },
    methods: {
      async loadTasksForJob() {
        const response = await this.$store.dispatch('tasks/fetchTasksByJobId', this.data.id)
        if (OK === response.status) {
          this.tasks = response.data
        }
      },
      assigneeName(userId) {
        const assignee = objectById(this.users, userId)

        if (assignee) {
          return getUserFullName(assignee)
        }

        return ''
      },
      handleSelectionChange(selectedTasks) {
        this.selectedTasks = selectedTasks
      },
      confirmTerminate() {
        const payload = {
          message: 'You are about to terminate the Camunda process associated with: <strong>' + this.data.name + '</strong>',
          delete: this.handleTerminate,
          showButton: true
        }
        this.$eventHub.$emit('show-modal-2', 'Confirm Terminate', payload, '600px')
      },
      async handleTerminate() {
        const ids = this.lodash.map(this.selectedTasks, 'id');
        const url = `jobs/terminateCamundaProcessInstanceDeletePtracTasksAndCompleteJob?jobId=${this.data.id}&processInstanceId=${this.data.processInstanceId}&taskIds=${ids.join(',')}`
        const response = await ptracDeleteEntity(url)

        if (NO_CONTENT === response.status) {
          notifySuccess(this, "Successfully terminated Camunda process, deleted PTRAC tasks, and completed the job")
          this.$eventHub.$emit('refreshProjectJobs', this.data)
          this.closeModal()
        } else {
          notifyError(this, "Failed to terminate: ", response.data.message)
        }
      },
      handleEditTask(taskId) {
        this.$eventHub.$emit('show-modal-2', 'Edit Task', {id: taskId})
      },
      selectableTask(task) {
        return !(Constants.STATUSES.COMPLETED === task.status)
      },
      closeModal () {
        this.$emit('close')
      },
      callStringSort(a, b, prop) {
        return stringSort(a, b, prop)
      },
    },
    beforeMount() {
      this.loadTasksForJob()
    }
}
</script>
